(function () {
  function getOffset() {
    var root = document.documentElement;
    var style = getComputedStyle(root);
    var announcementH = parseFloat(style.getPropertyValue('--announcement-bar-height')) || 0;
    var headerH = parseFloat(style.getPropertyValue('--header-height')) || 0;
    return announcementH + headerH + 20;
  }

  function findTarget() {
    return document.querySelector('[id*="blocks_4FUJae"]');
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.kd-made-in-link');
    if (!link) return;
    var target = findTarget();
    if (!target) return;
    e.preventDefault();
    var top = target.getBoundingClientRect().top + window.pageYOffset - getOffset();
    window.scrollTo({ top: top, behavior: 'smooth' });
  });
})();
